const VERSION = '2.3.0';
const ENV_SHARED = {
    CHECKOUT_API_BASE_PATH: '/checkout/api',
};
const ENV_DEV = {
    ...ENV_SHARED,
    STAGE: 'dev',
    CDN: 'https://cdn-dev.public.zooplus.net',
    OPTIMILELY_KEY: 'SwF3DzKPDLxqE1wmJnGxL',
};
const ENV_PROD = {
    ...ENV_SHARED,
    STAGE: 'prod',
    CDN: 'https://cdn.public.zooplus.net',
    OPTIMILELY_KEY: '6mvjLZXKn2AVXyUJ6rdUg',
};
const getEnv = (stage) => {
    switch (stage) {
        case 'dev':
            return ENV_DEV;
        case 'prod':
        default:
            return ENV_PROD;
    }
};

export { ENV_SHARED, VERSION, getEnv };
//# sourceMappingURL=environment.js.map
